// src/store/usePatientSearchStore.ts
import { create } from 'zustand'

export interface LocationData {
  address: string
  lat: number | null
  lng: number | null
}

interface PatientSearchState {
  // Search parameters
  location: LocationData | null
  radius: string | null
  insuranceId: string | null
  insuranceName: string | null
  specialtyId: string | null
  specialtyName: string | null
  
  // Actions
  setLocation: (location: LocationData | null) => void
  setRadius: (radius: string | null) => void
  setInsurance: (id: string | null, name: string | null) => void
  setSpecialty: (id: string | null, name: string | null) => void
  clearSearch: () => void
}

export const usePatientSearchStore = create<PatientSearchState>((set) => ({
  // Initial state
  location: null,
  radius: null,
  insuranceId: null,
  insuranceName: null,
  specialtyId: null,
  specialtyName: null,
  
  // Actions
  setLocation: (location) => {
    console.log("Setting location in store:", location)
    set({ location })
  },
  setRadius: (radius) => {
    console.log("Setting radius in store:", radius)
    set({ radius })
  },
  setInsurance: (insuranceId, insuranceName) => {
    console.log("Setting insurance in store:", { insuranceId, insuranceName })
    set({ insuranceId, insuranceName })
  },
  setSpecialty: (specialtyId, specialtyName) => {
    console.log("Setting specialty in store:", { specialtyId, specialtyName })
    set({ specialtyId, specialtyName })
  },
  clearSearch: () => {
    console.log("Clearing search in store")
    set({
      location: null,
      radius: null,
      insuranceId: null,
      insuranceName: null,
      specialtyId: null,
      specialtyName: null,
    })
  },
}))


// // src/store/usePatientSearchStore.ts - Updated with debugging
// import { create } from 'zustand'

// export interface LocationData {
//   address: string
//   lat: number | null
//   lng: number | null
// }

// interface PatientSearchState {
//   // Search parameters
//   location: LocationData | null
//   radius: string | null
//   insuranceId: string | null
//   insuranceName: string | null
//   specialtyId: string | null
//   specialtyName: string | null
  
//   // Actions
//   setLocation: (location: LocationData | null) => void
//   setRadius: (radius: string | null) => void
//   setInsurance: (id: string | null, name: string | null) => void
//   setSpecialty: (id: string | null, name: string | null) => void
//   clearSearch: () => void
//   updateSearch: (params: Partial<Omit<PatientSearchState, 'setLocation' | 'setRadius' | 'setInsurance' | 'setSpecialty' | 'clearSearch' | 'updateSearch'>>) => void
// }

// export const usePatientSearchStore = create<PatientSearchState>((set) => ({
//   // Initial state
//   location: null,
//   radius: null,
//   insuranceId: null,
//   insuranceName: null,
//   specialtyId: null,
//   specialtyName: null,
  
//   // Actions
//   setLocation: (location) => {
//     console.log("Setting location in store:", location)
//     set({ location })
//   },
//   setRadius: (radius) => {
//     console.log("Setting radius in store:", radius)
//     set({ radius })
//   },
//   setInsurance: (insuranceId, insuranceName) => {
//     console.log("Setting insurance in store:", { insuranceId, insuranceName })
//     set({ insuranceId, insuranceName })
//   },
//   setSpecialty: (specialtyId, specialtyName) => {
//     console.log("Setting specialty in store:", { specialtyId, specialtyName })
//     set({ specialtyId, specialtyName })
//   },
//   clearSearch: () => {
//     console.log("Clearing search in store")
//     set({
//       location: null,
//       radius: null,
//       insuranceId: null,
//       insuranceName: null,
//       specialtyId: null,
//       specialtyName: null,
//     })
//   },
//   updateSearch: (params) => {
//     console.log("Updating search in store:", params)
//     set((state) => ({ ...state, ...params }))
//   },
// }))